import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { CausaliMovmagService } from 'src/app/shared/services/causali-movmag.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { MovimentiMagazzinoService } from 'src/app/shared/services/movimenti-magazzino.service';
import { PopupAddMovMagazzinoComponent } from 'src/app/shared/components/popups/popup-add-mov-magazzino/popup-add-mov-magazzino.component';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import notify from 'devextreme/ui/notify';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { Articoli } from 'src/app/models/articoli';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";

@Component({
  selector: 'app-mov-mag',
  templateUrl: './mov-mag.component.html',
  styleUrls: ['./mov-mag.component.css'],
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    PopupAddMovMagazzinoComponent,
    DxoEditingComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxiValidationRuleComponent,
    DxoTextsComponent,
    CommonModule,
    DxoExportComponent,
  ],
  standalone: true,
})
export class MovMagComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private movMagService = inject(MovimentiMagazzinoService);
  private articoliService = inject(ArticoliService);
  private causaliService = inject(CausaliMovmagService);
  private articoliMatricolaService = inject(ArticoliMatricolaService);
  private navService = inject(NavigatorService);

  listArticoli: any;
  listCaus: any;
  listArticoliMatricola: any;
  dataSource: any;
  popupNuovoMovimentoMagVisible = false;
  gestMatricole: boolean;

  constructor() {
    super();
    this.gestMatricole = this.isModVisible('Matricole');
  }

  abs(value: any) {
    return Math.abs(value);
  }

  ngOnInit() {
    this.loadLookups();
    this.loadData();
  }

  loadLookups() {
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento articoli', 'error', 3000);
        }
      },
    });

    if (this.gestMatricole) {
      this.articoliMatricolaService.list().subscribe({
        next: (res) => {
          this.listArticoliMatricola = {
            store: {
              type: 'array',
              data: res,
              key: 'id',
            },
            pageSize: 10,
            paginate: true,
          };
        },
        error: (error) => {
          if (error?.error?.text) {
            const errT = error?.error?.text();
            const errj = JSON.parse(errT);
            notify(errj?.title, 'warning', 3000);
          } else {
            notify('Errore caricamento articoli matricola', 'error', 3000);
          }
        },
      });
    }

    this.causaliService.getListCausaliMovMagTemp().subscribe({
      next: (res) => {
        this.listCaus = {
          store: {
            type: 'array',
            data: res,
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento causali', 'error', 3000);
        }
      },
    });
  }

  loadData() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.movMagService.list())
          .then((response) => {
            return {
              data: response.sort((a, b) => {
                if (a.id > b.id) {
                  return -1;
                }
                if (a.id < b.id) {
                  return 1;
                }
                return 0;
              }),
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        //Data
        const dt = new Date(values.data);
        const realDay = dt.getDate();
        const realMonth = dt.getMonth();
        const realYear = dt.getFullYear();
        values.data = new Date(Date.UTC(realYear, realMonth, realDay));

        return firstValueFrom(this.movMagService.post(values)).catch(() => {
          throw 'Insertion failed';
        });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.movMagService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              console.log(error.error.title);
              throw error.error.title;
            })
        );
      },
    });
  }

  onInitNewRow() {
    /*setTimeout(() => {
      e.component.cancelEditData();
    }, 100);
    this.popupNuovoMovimentoMagVisible = true;
    */
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        name: 'nuovo',
        class: 'success',
        onClick: this.gotoNewMovimento(),
      },
    });
  }

  gotoNewMovimento() {
    this.navService.goToMovimentazioneNew();
  }

  onPopupNuovoMovimentoEvent(event: any) {
    this.popupNuovoMovimentoMagVisible = false;
    if (event) {
      this.loadData();
      if (this.gestMatricole) {
        this.articoliMatricolaService.list().subscribe({
          next: (res) => {
            this.listArticoliMatricola = {
              store: {
                type: 'array',
                data: res,
                key: 'id',
              },
              pageSize: 10,
              paginate: true,
            };
          },
          error: (error) => {
            if (error?.error?.text) {
              const errT = error?.error?.text();
              const errj = JSON.parse(errT);
              notify(errj?.title, 'warning', 3000);
            } else {
              notify('Errore caricamento articoli matricola', 'error', 3000);
            }
          },
        });
      }
    }
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }

  onExporting(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Movimento Magazzino');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,

      customizeCell: ({ gridCell, excelCell }) => {
        if (!gridCell) return;
        if (gridCell.rowType !== 'data') return;
        if (gridCell.column?.dataField === 'qtaRealValue') {
          const v = Number(gridCell.data?.qtaRealValue ?? 0);

          excelCell.value = Math.abs(v);

          excelCell.numFmt = '0.00';

          if (v > 0) {
            excelCell.font = { color: { argb: 'FF1B5E20' } };
          } else {
            excelCell.font = { color: { argb: 'FFB71C1C' } };
          }

          excelCell.alignment = { horizontal: 'right' };
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Movimento_Magazzino.xlsx',
        );
      });
    });

    e.cancel = true;
  }
}
